import GA from './ga-module';
import track from './tracking-module';

export * from './tracking-constants';

export default (eventName: string, event: object): void => track(eventName, event);

export const GATrack = (eventName: string, event: object): void => GA(eventName, event);
